import { BadgeIndianRupee, Users, UserCheck, ShieldCheck, ArrowRight } from "lucide-react";
import { T } from "@/i18n";

export const FeeInfo = ({ lang, onRegister }) => {
  const notes = [
    { icon: Users, text: T.fee.note1[lang], testId: "fee-note-1" },
    { icon: UserCheck, text: T.fee.note2[lang], testId: "fee-note-2" },
    { icon: ShieldCheck, text: T.fee.note3[lang], testId: "fee-note-3" },
  ];
  return (
    <section id="fee" data-testid="fee-section" className="relative py-20 sm:py-28">
      <div className="gc-waves" />
      <div className="relative z-10 mx-auto max-w-4xl px-4 sm:px-6">
        <p data-testid="fee-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
          {T.fee.sub[lang]}
        </p>
        <h2 data-testid="fee-heading" className={`mt-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
          {T.fee.heading[lang]}
        </h2>
        <div data-testid="fee-card" className="gc-card-sheen mt-12 rounded-3xl p-8 text-center sm:p-12">
          <BadgeIndianRupee className="mx-auto h-10 w-10 text-[#FFE500]" />
          <p data-testid="fee-price" className="mt-4 font-display text-6xl font-bold text-[#FFE500] sm:text-7xl">
            {T.fee.price[lang]}
          </p>
          <p data-testid="fee-per-person" className={`mt-1 text-sm uppercase tracking-[0.3em] text-white/60 ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
            {T.fee.perPerson[lang]}
          </p>
          <p data-testid="fee-includes" className={`mx-auto mt-5 max-w-md text-base text-white/80 ${lang === "kn" ? "font-kn" : ""}`}>
            {T.fee.includes[lang]}
          </p>
          <div className="mx-auto mt-8 max-w-lg space-y-3 text-left">
            {notes.map((n) => (
              <div key={n.testId} data-testid={n.testId} className="flex items-start gap-3 rounded-xl bg-white/[0.04] p-4">
                <n.icon className="mt-0.5 h-5 w-5 shrink-0 text-[#FFE500]" />
                <p className={`text-sm text-white/85 ${lang === "kn" ? "font-kn" : ""}`}>{n.text}</p>
              </div>
            ))}
          </div>
          <button
            data-testid="fee-register-btn"
            onClick={onRegister}
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#FFE500] px-10 py-4 font-display text-lg font-bold uppercase tracking-wider text-[#0B1233] shadow-[0_0_30px_rgba(255,229,0,0.3)] transition-all hover:scale-[1.03]"
          >
            {T.fee.cta[lang]} <ArrowRight className="h-5 w-5" />
          </button>
        </div>
      </div>
    </section>
  );
};
